"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WHATSAPP_API_URL = exports.PAYMENT_APP_URL = exports.GENERIC_BACK_OFFICE_ID = void 0;
const config_1 = require("../../utils/helpers/config");
exports.GENERIC_BACK_OFFICE_ID = 'generico';
exports.PAYMENT_APP_URL = `https://${config_1.envConfig.infraStage === 'homologation' ? 'h' : ''}pagamentos.grupoboticario.com.br`;
exports.WHATSAPP_API_URL = 'https://api.whatsapp.com';
